var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-page',{attrs:{"padding":""}},[_c('div',{staticClass:"flex-center row"},[_c('q-card',{staticClass:"col-4"},[_c('q-card-section',[_vm._v("\n        "+_vm._s(_vm.cart.name)+"\n      ")]),_c('q-card-section',[_c('q-btn',{attrs:{"color":"primary"},on:{"click":_vm.pay}},[_vm._v("Make Payment of $"+_vm._s(_vm.totalCost))])],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }